module.exports = __webpack_public_path__ + "img/组 495@2x.0626b7ff.png";